<div class="preview-container">
  <div *ngIf="accounts.length === 0" class="empty-state">
    <p>No accounts found with selected filters</p>
  </div>
  <div *ngIf="accounts.length > 0">
    <div class="preview-header">
    <span class="p-input-icon-left search-filter">
      <i class="pi pi-search"></i>
      <input
        pInputText
        [(ngModel)]="searchValue"
        class="account-search-bar"
        (input)="dtAccounts.filterGlobal($event.target.value, 'contains')"
        placeholder="Search Accounts..."/>
    </span>
    </div>
    <p-table
      #dtAccounts
      [value]="accounts"
      [globalFilterFields]="['name', 'id']"
      [scrollable]="true"
      scrollHeight="300px"
      styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Account Name</th>
          <th>Account ID (MPOP ID)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-account>
        <tr
          [ngClass]="{'excluded-row': !isAccountSelected(account)}"
          (click)="toggleAccountSelection(account)"
          class="clickable-row">
          <td>{{ account.name }}</td>
          <td>{{ account.id }}</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="selection-message">
      <ng-container *ngIf="getExcludedAccounts().length === 0; else excludedList">
        <p><i>Select Accounts to exclude from filter</i></p>
      </ng-container>
      <ng-template #excludedList>
        <p><strong>Excluded Accounts:</strong></p>
        <div class="excluded-chips">
          <span class="p-chip" *ngFor="let acc of getExcludedAccounts()">
            <span class="p-chip-text">{{ acc.name }} ({{ acc.id }})</span>
          </span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div class="preview-actions">
  <button
    pButton
    type="button"
    label="Clear Excluded"
    class="p-button-secondary p-mr-2"
    (click)="clearSelected()">
  </button>
  <button
    pButton
    type="button"
    label="Close"
    class="p-button-outlined"
    (click)="closeWithPayload()">
  </button>
</div>
